import { createFragmentContainer, graphql } from 'react-relay';
import ScheduleComponent from './ScheduleComponent';

export default createFragmentContainer(ScheduleComponent, {
  viewer: graphql`
    fragment ScheduleContainer_viewer on User {
      id
      s_time_zone
      ...AvailabilityCalendarContainer_viewer
    }
  `,
  node: graphql`
    fragment ScheduleContainer_node on UserEvent {
      id
      user_event_segments(first: 99999)
        @connection(key: "ScheduleContainer_user_event_segments") {
        edges {
          node {
            id
            title
            start_at
            end_at
            time_zone
            all_day
            location
            line1
            line2
            city
            province
            postal_code
            room
            notes
          }
        }
      }
    }
  `
});



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ScheduleContainer.js